import React,{Component} from "react";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import LeaveapplicationSelf from "./LeaveapplicationSelf";
import LeaveapplicationOther from "./LeaveapplicationOther";
const axios = require("axios");
const ref = React.createRef();
class LeaveApplication extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none"};
    }   
    render(){
        return(
/*}            <div style={{float:"right",paddingLeft:"2%",paddingRight:"2%",paddingTop: "60px",width:"85%",marginLeft: "0%"}} >*/
            <div className="container1">
                <br></br>
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"block"})                                                            
                            }}
                            >
                            <Tab label="For self" > </Tab> 
                            <Tab label="For other"></Tab>
                        </Tabs>
                    <div style={{display:this.state.tab1}}>
                         <LeaveapplicationSelf/>
                    </div>
                    <div style={{display:this.state.tab2}}>
                        <LeaveapplicationOther/>
                    </div>
                    <br></br><br></br>
            </div>
    )}
}
export default LeaveApplication;